const cookieHref = '/about/privacy-policy/#cookie';

export { cookieHref };
//# sourceMappingURL=cookies.js.map
